export default __webpack_public_path__ + "static/media/info.09582265.svg";